import React from 'react';
import { Link } from 'react-router-dom';
import { BookMarked } from 'lucide-react';
import type { SimilarCard } from '../../../services/supportApi';

interface SimilarCasesProps {
  cards: SimilarCard[];
  /** Percorso della scheda nella Base di conoscenza; assente = senza permesso di lettura. */
  cardPath?: (cardId: string) => string;
  /** Percorso del ticket di origine (solo se l'operatore puo aprirlo: `sourceTicketId`). */
  ticketPath?: (ticketId: string) => string;
}

/**
 * «Casi simili usati» sotto la proposta di «Proponi una risposta» (Task 29):
 * le schede approvate della base di conoscenza passate all'assistente.
 */
const SimilarCases: React.FC<SimilarCasesProps> = ({ cards, cardPath, ticketPath }) => {
  if (!cards.length) return null;
  return (
    <div className="s3-ai__cases">
      <span className="s3-label s3-ai__label">
        <BookMarked size={11} aria-hidden="true" /> Casi simili usati
      </span>
      <ul aria-label="Casi simili usati">
        {cards.map((c) => (
          <li key={c._id} className="s3-ai__case">
            {cardPath && c.cardAccessible !== false ? (
              <Link className="s3-link" to={cardPath(c._id)} target="_blank" rel="noopener noreferrer">
                {c.title}
              </Link>
            ) : (
              <span>{c.title}</span>
            )}
            {c.sourceTicketNumber &&
              (c.sourceTicketId && ticketPath ? (
                <Link className="s3-meta" to={ticketPath(c.sourceTicketId)} target="_blank" rel="noopener noreferrer">
                  ticket #{c.sourceTicketNumber}
                </Link>
              ) : (
                <span className="s3-meta">ticket #{c.sourceTicketNumber}</span>
              ))}
            {typeof c.score === 'number' && (
              <span className="s3-meta" title="Somiglianza con questa richiesta">
                {Math.round(Math.min(c.score, 1) * 100)}%
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SimilarCases;
